import { useLocation } from 'react-router-dom';

import { useDealer } from '../../../../../app/providers/DealerContext';
import { useFeatureServices } from '../../../../../shared/hooks/use-feature-services';
import { useHistory } from '../../../../../shared/hooks/use-history';
import { useMyVwContext } from '../../../../../shared/hooks/use-my-vw-context';
import { useToast } from '../../../../../shared/context/ToastContext';
import { useTrackingManager } from '../../../../../shared/hooks/use-tracking-manager';
import { useVehicle } from '../../../../../app/providers/VehicleContext';
import { ManageDealerLayerViewProps } from '../ManageDealerLayerContentView';

export function useManageDealerLayerData(): ManageDealerLayerViewProps {
  const { authService, translationHandler, baseUrl } = useMyVwContext();
  const trackingManager = useTrackingManager();
  const { 'locale-service': localeService } = useFeatureServices();
  const localeCode = `${localeService.language}-${localeService.countryCode}`;
  const isCanadaFrench = localeService?.countryCode === 'CA' && localeService?.language === 'fr';
  const locale = isCanadaFrench ? 'fr' : 'en';
  const { showToast } = useToast();
  const { userPreferredVehicle } = useVehicle();
  const history = useHistory();
  const { pathname: currentPathname } = useLocation();
  const {
    dealersList,
    fetchDealersListByZipCode,
    fetchPreferredDealer,
    getUserLocation,
    isLoadingDealers,
    isLoadingPreferredDealer,
    noDealersFound,
    userPreferredDealer,
  } = useDealer();

  return {
    titleKey: userPreferredDealer
      ? 'accountSettings.manageDealer.already.dealer'
      : 'accountSettings.manageDealer.none.dealer.label2',
    translationHandler,
    trackingManager,
    authService,
    dealersList,
    fetchDealersListByZipCode,
    fetchPreferredDealer,
    getUserLocation,
    isLoadingDealers,
    isLoadingPreferredDealer,
    noDealersFound,
    userPreferredDealer,
    localeCode,
    locale,
    showToast,
    userPreferredVehicle,
    history,
    currentPathname,
    baseUrl,
  };
}
